import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { User, Organization, Brand } from './types';

interface AuthState {
  user: User | null;
  accessToken: string | null;
  refreshToken: string | null;
  currentOrganization: Organization | null;
  currentBrand: Brand | null;
  organizations: Organization[];
  brands: Brand[];
  isLoading: boolean;
  error: string | null;

  // Actions
  setUser: (user: User | null) => void;
  setTokens: (accessToken: string | null, refreshToken: string | null) => void;
  setCurrentOrganization: (org: Organization | null) => void;
  setCurrentBrand: (brand: Brand | null) => void;
  clearBrandAndBrands: () => void;
  setOrganizations: (orgs: Organization[]) => void;
  setBrands: (brands: Brand[]) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      accessToken: null,
      refreshToken: null,
      currentOrganization: null,
      currentBrand: null,
      organizations: [],
      brands: [],
      isLoading: true,
      error: null,

      setUser: (user) => set({ user }),
      setTokens: (accessToken, refreshToken) => set({ accessToken, refreshToken }),
      setCurrentOrganization: (currentOrganization) => set({ currentOrganization }),
      setCurrentBrand: (currentBrand) => set({ currentBrand }),
      clearBrandAndBrands: () => set({ currentBrand: null, brands: [] }),
      setOrganizations: (organizations) => set({ organizations }),
      setBrands: (brands) => set({ brands }),
      setLoading: (isLoading) => set({ isLoading }),
      setError: (error) => set({ error }),
      logout: () => set({
        user: null,
        accessToken: null,
        refreshToken: null,
        currentOrganization: null,
        currentBrand: null,
        organizations: [],
        brands: [],
      }),
    }),
    {
      name: 'pollenate-auth',
      partialize: (state) => ({
        accessToken: state.accessToken,
        refreshToken: state.refreshToken,
        currentOrganization: state.currentOrganization,
        currentBrand: state.currentBrand,
      }),
    }
  )
);
